import React, { useContext } from 'react';
import { ThemeContext } from './ThemeContext';
import { Sun, Moon } from 'react-feather'; // Using react-feather for icons

const ThemeToggleButton = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);

  if (!toggleTheme) return null;

  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      className="theme-toggle-btn"
      aria-label="Toggle theme"
      aria-pressed={isDark}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      <Sun size={16} style={{ opacity: isDark ? 0.6 : 1 }} />
      <Moon size={16} style={{ opacity: isDark ? 1 : 0.6 }} />
    </button>
  );
};

export default ThemeToggleButton;